import { render, staticRenderFns } from "./CuadreServicioForm.vue?vue&type=template&id=19235168&scoped=true&"
import script from "./CuadreServicioForm.vue?vue&type=script&lang=ts&"
export * from "./CuadreServicioForm.vue?vue&type=script&lang=ts&"
import style0 from "./CuadreServicioForm.vue?vue&type=style&index=0&id=19235168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19235168",
  null
  
)

export default component.exports